export const generateMultipleWhatsAppLink = (diamonds) => {
  if (!diamonds || diamonds.length === 0) return '';
  
  let message = `Hi, I'm interested in the following diamonds:\n\n`;
  
  diamonds.forEach((diamond, index) => {
    message += `${index + 1}. ${diamond.shape} Diamond\n`;
    if (diamond.stock_id) message += `   Stock ID: ${diamond.stock_id}\n`;
    message += `   Size: ${diamond.size} carat\n`;
    message += `   Color: ${diamond.colour}\n`;
    message += `   Clarity: ${diamond.clarity}\n`;
    message += `   Cut: ${diamond.cut}\n`;
    if (diamond.certificate) message += `   Certificate: ${diamond.certificate}\n`;
    if (diamond.lab) message += `   Lab: ${diamond.lab}\n`;
    message += `\n`;
  });
  
  message += `Please provide more details and pricing for these diamonds.`;
  
  const phone = '+918128741058';
  return `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
};
